export enum ModuleTokens {
  Name = 'ticketRating'
}
